import { ApiBaseHandler } from "../../infrastructure/base-handlers";
import { translate } from "../../localization";
import { ExportPdfModal } from "./export-pdf-modal/export-pdf-modal";

export class ExportToPdfHandler extends ApiBaseHandler {
  async handle() {
    try {
      this.api.interactionService.confirm(undefined, {component: ExportPdfModal}, {
        title: translate("modal.selectExportOption"),
        confirmButtonText: "Exportar",
        cancelButtonText: "Cancelar",
      });
    } catch (error) {
      this._notifyError(error.message);
    }
  }

  _notifyError(errorMessage?: string) {
    this.api.notificationService.error(
      errorMessage || "actions.delete.error",
    );
  }
}
